import { render, staticRenderFns } from "./changeUserPassw.vue?vue&type=template&id=082b754a&scoped=true&"
import script from "./changeUserPassw.vue?vue&type=script&lang=js&"
export * from "./changeUserPassw.vue?vue&type=script&lang=js&"
import style0 from "./changeUserPassw.vue?vue&type=style&index=0&id=082b754a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082b754a",
  null
  
)

export default component.exports